<div class="electron-drag-bar"></div>

<header>
  <banner></banner>
</header>
@if (activePage()) {
  <main>
    <button
      class="close-btn"
      mat-icon-button
      (click)="closeOverlay()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <!-- Mode selector is now integrated into focus-mode-main component -->

    <!-- -->
    @switch (activePage()) {
      <!-- -->
      @case (FocusScreen.Main) {
        <focus-mode-main @warpIn></focus-mode-main>
      }
      @case (FocusScreen.SessionDone) {
        <focus-mode-session-done @warpIn></focus-mode-session-done>
      }
      @case (FocusScreen.Break) {
        <focus-mode-break @warpIn></focus-mode-break>
      }
    }
  </main>
}
